import { posts } from "assets/data/posts";
import { FeedPost } from "components";
import ReportPostsLayout from "layouts/ReportPostsLayout";

const SpamReports = () => {
    return (
        <ReportPostsLayout breadCrumbTitle="Spam" title="Spam Posts Reports">
            <>
                {posts.slice(3, 6).map((i) => (
                    <FeedPost post={i} key={i.id} />
                ))}
            </>
        </ReportPostsLayout>
    );
};

export default SpamReports;
